import { ToplineMetric } from 'app/model/metrics/topline-metric';
import { RestfulApiService } from 'app/services/restful-api.service';

class StoreMetricsService extends RestfulApiService<ToplineMetric> {
    protected getFormName(): string {
        return '';
    }

    protected getPath(): string {
        return 'metrics/stores';
    }
}

export const storeMetricService = new StoreMetricsService();
